var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.541,
    height: 12.823,
    viewBox: "0 0 11.541 12.823",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#757575;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M13.259,12.541H4.282V5.488h8.976M11.335,1V2.282H6.206V1H4.924V2.282H4.282A1.278,1.278,0,0,0,3,3.565v8.976a1.282,1.282,0,0,0,1.282,1.282h8.976a1.282,1.282,0,0,0,1.282-1.282V3.565a1.282,1.282,0,0,0-1.282-1.282h-.641V1m-.641,7.053H8.771v3.206h3.206Z",
    transform: "translate(-3 -1)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.c049892cf5b8cec71b20805903400f6d.svg";
export { ForwardRef as ReactComponent };